import { render, staticRenderFns } from "./FrontConfigAccessesExtra.vue?vue&type=template&id=c4445230&scoped=true&"
import script from "./FrontConfigAccessesExtra.vue?vue&type=script&lang=js&"
export * from "./FrontConfigAccessesExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4445230",
  null
  
)

export default component.exports